module.exports = __webpack_public_path__ + "img/south-korea.8a067f19.svg";